import React, { cloneElement, Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../../common/Button";
import Tooltip from "../../../../../../learning/presentational/body/input/numberKeypad/submitButtons/Tooltip";
import { useUserInfo } from "../../../../../../../../hooks";
import { TYPE } from "../../../../../../../../constant";

const SubmitButtons = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const keypad = useSelector( state => state.keypad );
  const notepad = useSelector( state => state.notepad );

  const { t } = useTranslation();
  const { info } = useUserInfo();

  const {
    children,
    ...PROPS
  } = props;


  return (
    <table summary="키패드">
      <tbody>
      <tr>
        <td className="left">
          { cloneElement( children || <Fragment />, { ...PROPS } ) }
        </td>
        <td className="grading">
          <Button className="btn btn-green" disabled={ ! answeringQuestions.isNextQuestion || notepad?.isEditing } onClick={ props.onAnswering }>{ t( 'LC_02_06.msg007' ) }</Button>
        </td>
        {
          info.channelCode !== TYPE.CHANNEL.GLOBAL01 && (
            <td className="arr_area">
              <Button className="lr_arr" onClick={ props.onPrevCursor }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lctest_answermove_back.svg` } alt="" /></Button>
              <Button className="lr_arr" onClick={ props.onNextCursor }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lctest_answermove_next.svg` } alt="" /></Button>
                {!!keypad.arrowKeyTooltipStatus && <Tooltip fadeTooltip={props.fadeTooltip} /> }
            </td>
          )
        }
      </tr>
      </tbody>
    </table>
  );

};

export default SubmitButtons;
